import PropTypes from 'prop-types';
import './tabla.css';

// Anchos de las barras de relleno: varían por fila y columna para que no parezca una rejilla.
const ANCHOS = [78, 62, 90, 54, 70, 84, 58, 66];
const ancho = (fila, col) => `${ANCHOS[(fila * 3 + col) % ANCHOS.length]}%`;

/** Filas de relleno para el cuerpo de una tabla que ya tiene su cabecera (al reordenar o filtrar). */
const FilasEsqueleto = ({ columnas, filas = 10, conSeleccion = false }) =>
  Array.from({ length: filas }, (_f, i) => (
    <tr key={`esq${i}`} className="tbl-esq-fila" aria-hidden="true">
      {conSeleccion && (
        <td className="tbl-sel">
          <span className="tbl-esq" style={{ width: 14 }} />
        </td>
      )}
      {columnas.map((c, j) => (
        <td key={c.id}>
          <span className="tbl-esq" style={{ width: ancho(i, j) }} />
        </td>
      ))}
    </tr>
  ));

FilasEsqueleto.propTypes = {
  columnas: PropTypes.array.isRequired,
  filas: PropTypes.number,
  conSeleccion: PropTypes.bool,
};

export default FilasEsqueleto;
